// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"31ce38fc","402":"01b90422","475":"3f041870","937":"abc261a8"}[chunkId] + ".chunk.css";
};